(function(){
  function hide(el){ if(el) el.style.setProperty('display','none','important'); }
  function run(){
    document.querySelectorAll('[data-lts-gallery-hide]').forEach(function(m){
      var li=m.closest('.product__media-item');
      if(!li||!li.id)return;
      hide(document.querySelector('.thumbnail-list__item[data-target="'+li.id+'"]'));
      var bare=li.id.split('-').pop();
      document.querySelectorAll('.product-media-modal [data-media-id="'+bare+'"]').forEach(hide);
    });
  }
  run();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);
  window.addEventListener('load',run);
})();
